import React, { createContext, useContext } from "react";
import { ApolloProvider as ReactApolloProvider, ApolloConsumer } from "@apollo/react-hooks";
import ApolloClient from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { useAuthDataContext } from "components/auth";
import { tiiviiGraphqlUrl } from "config/paths";

export const ApolloContext = createContext(null);
export let client = null;

const ApolloProvider = ({ children }) => {
  const { token } = useAuthDataContext();

  const httpLink = createHttpLink({
    uri: tiiviiGraphqlUrl,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    },
  }));

  const defaultOptions = {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "ignore",
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all",
    },
    mutate: {
      fetchPolicy: "no-cache",
    },
  };

  client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions,
  });

  return (
    <ReactApolloProvider client={client}>
      <ApolloConsumer>
        {client => <ApolloContext.Provider value={client}>{children}</ApolloContext.Provider>}
      </ApolloConsumer>
    </ReactApolloProvider>
  );
};

export const useApolloContext = () => {
  const context = useContext(ApolloContext);
  if (context === undefined) {
    throw new Error("useApolloContext must be used within a ApolloProvider");
  }
  return context;
};

export default ApolloProvider;
